import React from "react";
import Step1 from "./steps/Step1";
import Step2 from "./steps/Step2";
import Step3 from "./steps/Step3";
import {
  formatCreditCardNumber,
  formatCVC,
  formatExpirationDate
} from "../../assets/js/utils.js";
import { getBackendBaseUrl, getIntuitPaymentsBaseUrl } from "./paymentsConfig";
import "./DataWizard.css";

class DataWizard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 1,
      formData: {
        step1: {
          nomeCompleto: "",
          email: "",
          celular: "",
          countryCode: "US",
          countryDialCode: "+1",
          consentimento: false
        },
        step2: {
          campusOption: "",
          classOption: ""
        },
        step3: {
          campo1: "",
          campo2: "",
          campo3: ""
        }
      },
      payment: {
        modalPaymentIsOpen: false,
        cardInformation: {
          name: "",
          number: "",
          expiry: "",
          cvc: "",
          postalCode: "",
          focused: ""
        },
        saveCardConsent: true,
        paymentError: "",
        isPaying: false
      },
      discount: {
        code: null,
        percentage: 0,
        isValidating: false
      },
      urlDiscount: {
        code: null,
        percentage: 0
      },
      swift69Discount: {
        code: null,
        percentage: 0
      }
    };
  }

  getEmptyCardInformation = () => ({
    name: "",
    number: "",
    expiry: "",
    cvc: "",
    postalCode: "",
    focused: ""
  });

  componentDidMount() {
    // REMOVER IFRAMES IMEDIATAMENTE
    this.removeBlockingIframes();
    this.setupIframeObserver();

    // Garantir que nenhum script global interfira com nosso wizard
    this.isolateWizard();

    // Verificar código de desconto na URL
    this.checkDiscountCode();

    // Pre-fetch Swift69 discount code
    this.prefetchSwift69Discount();

    // Forçar inputs a serem habilitados após montagem
    setTimeout(() => {
      this.removeBlockingIframes();
      this.enableAllInputs();
      this.startInputKeepAlive();
    }, 100);

    setTimeout(() => {
      this.removeBlockingIframes();
      this.enableAllInputs();
    }, 500);
  }

  componentDidUpdate(prevProps, prevState) {
    // Scroll para o topo quando o step mudar
    if (prevState.currentStep !== this.state.currentStep) {
      this.scrollToTop();
    }

    // Garantir que inputs permaneçam habilitados após updates
    setTimeout(() => {
      this.enableAllInputs();
    }, 0);
  }

  scrollToTop = () => {
    // Scroll do container do wizard
    const wizardContainer = document.querySelector(".data-wizard-container");
    if (wizardContainer) {
      wizardContainer.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }
    // Também scroll da window caso necessário
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  };

  componentWillUnmount() {
    if (this.iframeObserver) {
      this.iframeObserver.disconnect();
    }
    if (this.inputKeepAliveInterval) {
      clearInterval(this.inputKeepAliveInterval);
    }
  }

  removeBlockingIframes = () => {
    const iframes = document.querySelectorAll("iframe");
    iframes.forEach((iframe) => {
      const style = window.getComputedStyle(iframe);
      const rect = iframe.getBoundingClientRect();

      if (
        (rect.width > window.innerWidth * 0.9 &&
          rect.height > window.innerHeight * 0.9) ||
        parseInt(style.zIndex) > 90000
      ) {
        iframe.style.display = "none";
        iframe.remove();
      }
    });

    document.body.querySelectorAll("iframe").forEach((iframe) => {
      const style = window.getComputedStyle(iframe);
      if (parseInt(style.zIndex) > 90000) {
        iframe.remove();
      }
    });
  };

  setupIframeObserver = () => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeName === "IFRAME") {
            const style = window.getComputedStyle(node);
            if (parseInt(style.zIndex) > 90000) {
              node.remove();
            }
          } else if (node.querySelectorAll) {
            const iframes = node.querySelectorAll("iframe");
            iframes.forEach((iframe) => {
              const style = window.getComputedStyle(iframe);
              if (parseInt(style.zIndex) > 90000) {
                iframe.remove();
              }
            });
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    this.iframeObserver = observer;
  };

  startInputKeepAlive = () => {
    // Intervalo para manter inputs sempre habilitados
    if (this.inputKeepAliveInterval) {
      clearInterval(this.inputKeepAliveInterval);
    }

    this.inputKeepAliveInterval = setInterval(() => {
      const inputs = document.querySelectorAll(
        '.data-wizard-container input[type="text"], .data-wizard-container input[type="email"], .data-wizard-container input[type="tel"]'
      );
      inputs.forEach((input) => {
        if (input.disabled) {
          input.disabled = false;
          input.removeAttribute("disabled");
        }
      });
    }, 100);
  };

  isolateWizard = () => {
    // Criar um namespace isolado para nosso wizard
    const wizardContainer = document.querySelector(".data-wizard-container");
    if (wizardContainer) {
      // Prevenir que eventos sejam capturados por scripts globais
      wizardContainer.addEventListener(
        "click",
        (e) => {
          // Permitir que eventos nos inputs passem
          if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA") {
            return true;
          }
        },
        true
      );

      wizardContainer.addEventListener(
        "mousedown",
        (e) => {
          if (e.target.tagName === "INPUT" || e.target.tagName === "TEXTAREA") {
            e.stopPropagation();
            return true;
          }
        },
        true
      );
    }
  };

  enableAllInputs = () => {
    const inputs = document.querySelectorAll(
      '.data-wizard-container input[type="text"], .data-wizard-container input[type="email"], .data-wizard-container input[type="tel"]'
    );
    inputs.forEach((input) => {
      input.disabled = false;
      input.readOnly = false;
      input.style.pointerEvents = "auto";
      input.style.cursor = "text";
      input.style.zIndex = "999999";
      input.style.position = "relative";
      input.style.opacity = "1";

      // Adicionar listener direto no DOM com capture phase para sobrescrever jQuery
      const clickHandler = function (e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        this.focus();
      };

      const mouseDownHandler = function (e) {
        e.stopPropagation();
        e.stopImmediatePropagation();
      };

      // Remover listeners antigos e adicionar novos
      input.removeEventListener("click", clickHandler, true);
      input.removeEventListener("mousedown", mouseDownHandler, true);
      input.addEventListener("click", clickHandler, true);
      input.addEventListener("mousedown", mouseDownHandler, true);
    });

    // Garantir que checkboxes e botões também funcionem
    const checkboxes = document.querySelectorAll(
      '.data-wizard-container input[type="checkbox"]'
    );
    checkboxes.forEach((checkbox) => {
      checkbox.style.pointerEvents = "auto";
      checkbox.style.cursor = "pointer";
      checkbox.style.zIndex = "999999";
      checkbox.style.position = "relative";
    });

    const buttons = document.querySelectorAll(".data-wizard-container button");
    buttons.forEach((button) => {
      button.style.pointerEvents = "auto";
      button.style.cursor = button.disabled ? "not-allowed" : "pointer";
      button.style.zIndex = "999999";
      button.style.position = "relative";
    });
  };

  nextStep = () => {
    if (this.state.currentStep < 3) {
      this.setState(
        {
          currentStep: this.state.currentStep + 1
        },
        () => {
          // Scroll para o topo após mudar de step
          this.scrollToTop();
        }
      );
    }
  };

  prevStep = () => {
    if (this.state.currentStep > 1) {
      this.setState(
        {
          currentStep: this.state.currentStep - 1
        },
        () => {
          // Scroll para o topo após mudar de step
          this.scrollToTop();
        }
      );
    }
  };

  handleInputChange = (step, field, value) => {
    this.setState((prevState) => ({
      formData: {
        ...prevState.formData,
        [step]: {
          ...prevState.formData[step],
          [field]: value
        }
      }
    }));
  };

  handleSubmit = (e) => {
    e.preventDefault();

    // Se o desconto for 100%, não abrir modal de pagamento, chamar finishSubmit diretamente
    if (this.state.discount.percentage === 100) {
      this.finishSubmit(null);
      return;
    }

    // Abrir modal de pagamento
    this.toggleModalPayment();
  };

  toggleModalPayment = () => {
    return new Promise((resolve) => {
      this.setState((prevState) => {
        const nextIsOpen = !prevState.payment.modalPaymentIsOpen;

        // Ao fechar: limpar qualquer dado sensível do state imediatamente
        if (nextIsOpen === false) {
          return {
            payment: {
              ...prevState.payment,
              modalPaymentIsOpen: false,
              isPaying: false,
              paymentError: "",
              cardInformation: this.getEmptyCardInformation(),
              saveCardConsent: true
            }
          };
        }

        // Ao abrir: resetar erros e garantir UI consistente
        return {
          payment: {
            ...prevState.payment,
            modalPaymentIsOpen: true,
            isPaying: false,
            paymentError: "",
            saveCardConsent: true
          }
        };
      }, resolve);
    });
  };

  handleSaveCardConsentChange = (e) => {
    const checked = Boolean(e?.target?.checked);
    this.setState((prevState) => ({
      payment: {
        ...prevState.payment,
        saveCardConsent: checked
      }
    }));
  };

  handleCardInputChange = (e) => {
    const { name, value } = e.target;
    let valueResult = value;

    this.setState((prevState) => {
      const currentCardInfo = prevState.payment.cardInformation;

      if (name === "number") {
        valueResult = formatCreditCardNumber(value);
      } else if (name === "expiry") {
        valueResult = formatExpirationDate(value);
      } else if (name === "cvc") {
        valueResult = formatCVC(value, currentCardInfo.cvc, {
          number: currentCardInfo.number
        });
      }

      return {
        payment: {
          ...prevState.payment,
          cardInformation: {
            ...currentCardInfo,
            [name]: valueResult
          }
        }
      };
    });
  };

  handleInputFocus = (e) => {
    this.setState((prevState) => ({
      payment: {
        ...prevState.payment,
        cardInformation: {
          ...prevState.payment.cardInformation,
          focused: e.target.name
        }
      }
    }));
  };

  getCardNumberDigits = () => {
    const value = this.state.payment?.cardInformation?.number || "";
    return value.replace(/\s+/g, "").replace(/\D+/g, "");
  };

  parseExpiry = () => {
    const raw = this.state.payment?.cardInformation?.expiry || "";
    const digits = raw.replace(/\D+/g, "");
    if (digits.length < 4) return null;

    const mm = digits.slice(0, 2);
    const yy = digits.slice(2, 4);
    const month = parseInt(mm, 10);
    const year2 = parseInt(yy, 10);

    if (!month || month < 1 || month > 12) return null;

    // Converter YY -> YYYY (assumindo 2000-2099)
    const year4 = 2000 + year2;

    return {
      expMonth: mm,
      expYear2: yy,
      expYear4: String(year4)
    };
  };

  isCardFormValid = () => {
    const card = this.state.payment?.cardInformation || {};
    const name = (card.name || "").trim();
    const numberDigits = this.getCardNumberDigits();
    const expiry = this.parseExpiry();
    const cvc = (card.cvc || "").replace(/\D+/g, "");
    const postalCode = (card.postalCode || "").trim();

    if (name.length === 0) return false;
    if (numberDigits.length < 13 || numberDigits.length > 19) return false;
    if (!expiry) return false;
    if (cvc.length < 3) return false;
    if (postalCode.length < 3) return false;

    // Não permitir expiração no passado
    const now = new Date();
    const currentMonth = now.getMonth() + 1;
    const currentYear = now.getFullYear();
    const expMonthNum = parseInt(expiry.expMonth, 10);
    const expYearNum = parseInt(expiry.expYear4, 10);
    if (expYearNum < currentYear) return false;
    if (expYearNum === currentYear && expMonthNum < currentMonth) return false;

    return true;
  };

  newRequestId = () => {
    if (typeof crypto !== "undefined" && crypto.randomUUID) {
      return crypto.randomUUID();
    }
    return `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  };

  getPaymentsAccessToken = async () => {
    const url = getBackendBaseUrl();
    const response = await fetch(`${url}/api/intuit/payments-access-token`, {
      method: "GET",
      headers: { "Content-Type": "application/json" }
    });

    let data;
    try {
      data = await response.json();
    } catch (e) {
      throw new Error("Resposta inválida do servidor (token).");
    }

    const accessToken = data && (data.accessToken || data.data?.accessToken);
    if (!response.ok || !accessToken) {
      throw new Error(
        "Não foi possível obter token de acesso para pagamentos."
      );
    }
    return accessToken;
  };

  tokenizeCardWithIntuit = async (accessToken) => {
    const expiry = this.parseExpiry();
    if (!expiry) {
      throw new Error("Validade do cartão inválida.");
    }

    const card = this.state.payment?.cardInformation || {};
    const requestId = this.newRequestId();
    const intuitBaseUrl = getIntuitPaymentsBaseUrl();
    const tokensUrl = `${intuitBaseUrl}/quickbooks/v4/payments/tokens`;

    const body = {
      card: {
        name: (card.name || "").trim(),
        number: this.getCardNumberDigits(),
        expMonth: expiry.expMonth,
        expYear: expiry.expYear4,
        cvc: (card.cvc || "").replace(/\D+/g, ""),
        address: {
          postalCode: (card.postalCode || "").trim(),
          country: "US"
        }
      }
    };

    const response = await fetch(tokensUrl, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
        "Request-Id": requestId
      },
      body: JSON.stringify(body)
    });

    let data;
    try {
      data = await response.json();
    } catch (e) {
      throw new Error("Falha ao tokenizar cartão (resposta inválida).");
    }

    const tokenValue = data && (data.value || data.tokenValue);
    if (!response.ok || !tokenValue) {
      const errorMessage =
        data?.errors?.[0]?.message ||
        data?.message ||
        "Falha ao tokenizar cartão.";
      throw new Error(errorMessage);
    }

    return tokenValue;
  };

  getApplicationCampus = () => {
    const campus = this.state.formData.step2.campusOption;
    if (campus === "Salt Lake City (In Person)") {
      return "Salt Lake City";
    } else if (campus === "Orem (In Person)") {
      return "Orem";
    } else if (campus === "Seattle (In Person)") {
      return "Seattle";
    } else if (campus === "Online") {
      return "Online";
    }
    return "";
  };

  getPrice = () => {
    const { step2 } = this.state.formData;
    if (!step2 || !step2.campusOption) return 0;

    const campus = step2.campusOption;
    let basePrice = 0;
    if (campus === "Online") {
      basePrice = 99.0;
    } else if (
      campus === "Salt Lake City (In Person)" ||
      campus === "Orem (In Person)"
    ) {
      basePrice = 149.0;
    } else if (campus === "Seattle (In Person)") {
      basePrice = 179.0;
    }

    // Aplicar desconto se houver
    const discountPercentage = this.state.discount.percentage || 0;
    if (discountPercentage > 0) {
      return basePrice * (1 - discountPercentage / 100);
    }

    return basePrice;
  };

  getBasePrice = () => {
    const { step2 } = this.state.formData;
    if (!step2 || !step2.campusOption) return 0;

    const campus = step2.campusOption;
    if (campus === "Online") {
      return 99.0;
    } else if (
      campus === "Salt Lake City (In Person)" ||
      campus === "Orem (In Person)"
    ) {
      return 149.0;
    } else if (campus === "Seattle (In Person)") {
      return 179.0;
    }
    return 0;
  };

  checkDiscountCode = async () => {
    // Extrair código da URL
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get("code");

    if (!code) {
      return; // Não há código na URL, não fazer nada
    }

    // Validar código e armazenar como URL discount
    await this.validateDiscountCode(code);
  };

  validateDiscountCode = async (code) => {
    this.setState((prevState) => ({
      discount: {
        ...prevState.discount,
        isValidating: true
      }
    }));

    try {
      const url = getBackendBaseUrl();

      const response = await fetch(
        `${url}/partners/validatecode?code=${encodeURIComponent(code)}`
      );
      const data = await response.json();

      if (data.success === true && data.data && data.data.discountPercentage) {
        // Store as URL discount and also set as active discount
        this.setState({
          discount: {
            code: code,
            percentage: data.data.discountPercentage,
            isValidating: false
          },
          urlDiscount: {
            code: code,
            percentage: data.data.discountPercentage
          }
        });
      } else {
        // Código inválido, não aplicar desconto
        this.setState({
          discount: {
            code: null,
            percentage: 0,
            isValidating: false
          }
        });
      }
    } catch (error) {
      console.error("Erro ao validar código de desconto:", error);
      // Em caso de erro, não aplicar desconto
      this.setState({
        discount: {
          code: null,
          percentage: 0,
          isValidating: false
        }
      });
    }
  };

  prefetchSwift69Discount = async () => {
    try {
      const url = getBackendBaseUrl();

      const response = await fetch(
        `${url}/partners/validatecode?code=${encodeURIComponent("Swift69")}`
      );
      const data = await response.json();

      if (data.success === true && data.data && data.data.discountPercentage) {
        this.setState({
          swift69Discount: {
            code: "Swift69",
            percentage: data.data.discountPercentage
          }
        });
      }
    } catch (error) {
      console.error("Erro ao pré-buscar código Swift69:", error);
    }
  };

  handleCampusChange = (campusValue) => {
    // Apply discount logic based on campus selection
    if (campusValue === "Online") {
      // Apply Swift69 discount
      if (this.state.swift69Discount.code) {
        this.setState({
          discount: {
            code: this.state.swift69Discount.code,
            percentage: this.state.swift69Discount.percentage,
            isValidating: false
          }
        });
      }
    } else {
      // Restore URL discount if it exists, otherwise clear discount
      if (this.state.urlDiscount.code) {
        this.setState({
          discount: {
            code: this.state.urlDiscount.code,
            percentage: this.state.urlDiscount.percentage,
            isValidating: false
          }
        });
      } else {
        this.setState({
          discount: {
            code: null,
            percentage: 0,
            isValidating: false
          }
        });
      }
    }
  };

  isPaying = (bool) => {
    return new Promise((resolve) => {
      this.setState(
        (prevState) => ({
          payment: {
            ...prevState.payment,
            isPaying: bool
          }
        }),
        resolve
      );
    });
  };

  setPaymentError = (msg) => {
    return new Promise((resolve) => {
      this.setState(
        (prevState) => ({
          payment: {
            ...prevState.payment,
            paymentError: msg
          }
        }),
        resolve
      );
    });
  };

  setupCardOnFile = async ({ tokenValue, chargeNow, saveCard }) => {
    const url = getBackendBaseUrl();
    const stateObj = { ...this.state.formData };

    const total = this.getPrice().toFixed(2);
    const payload = {
      tokenValue,
      chargeNow: Boolean(chargeNow),
      saveCard: Boolean(saveCard),
      applicationContext: {
        applicationChoice: "Swift",
        campus: this.getApplicationCampus(),
        period:
          stateObj.step2.classOption &&
          stateObj.step2.classOption.includes("Saturday")
            ? "Saturday Morning"
            : "Tuesday Thursday Evening",
        partnerCode: this.state.discount.code || null,
        partnerDiscountPercentage: this.state.discount.percentage || 0
      },
      applicant: {
        fullName: stateObj.step1.nomeCompleto,
        email: stateObj.step1.email,
        phone: stateObj.step1.celular
      }
    };

    if (payload.chargeNow) {
      payload.amount = total;
      payload.currency = "USD";
    }

    const response = await fetch(`${url}/api/payments/setup-card-on-file`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    });

    let data;
    try {
      data = await response.json();
    } catch (e) {
      throw new Error("Resposta inválida do servidor (pagamento).");
    }

    const paymentIdForApply =
      data && (data.paymentIdForApply || data.data?.paymentIdForApply);

    const customerId = data && (data.customerId || data.data?.customerId);

    if (!response.ok || !paymentIdForApply) {
      const message =
        data?.messages?.map((m) => m).join("\n") ||
        data?.errors?.[0]?.message ||
        data?.message ||
        "Falha ao salvar cartão para cobrança.";
      throw new Error(message);
    }

    return { paymentIdForApply, customerId, raw: data };
  };

  pay = async (e) => {
    e.preventDefault();

    if (this.state.payment.isPaying === false) {
      await this.isPaying(true);

      try {
        const mode = this.props.paymentMode || "charge_and_save";
        const chargeNow = mode === "charge_and_save";
        const saveCardConsent = this.state.payment.saveCardConsent === true;

        // charge_and_save: cobra sempre, salva apenas se houver consentimento explícito
        // save_only: exige consentimento (não faz sentido "salvar" sem consentimento)
        const saveCard =
          mode === "save_only"
            ? true
            : mode === "charge_and_save" && saveCardConsent;

        if (mode === "save_only" && !saveCardConsent) {
          const { t } = this.props;
          const translate = t || ((key) => key);
          await this.isPaying(false);
          await this.setPaymentError(translate("saveCardConsentRequired"));
          return;
        }

        if (!this.isCardFormValid()) {
          const { t } = this.props;
          const translate = t || ((key) => key);
          await this.isPaying(false);
          await this.setPaymentError(translate("invalidPaymentForm"));
          return;
        }

        const accessToken = await this.getPaymentsAccessToken();
        const tokenValue = await this.tokenizeCardWithIntuit(accessToken);

        const { paymentIdForApply, customerId } = await this.setupCardOnFile({
          tokenValue,
          chargeNow,
          saveCard
        });

        // Fechar modal e limpar dados sensíveis antes de continuar
        await this.toggleModalPayment();

        if (mode === "charge_and_save") {
          await this.finishSubmit(paymentIdForApply, customerId);
          return;
        }

        // save_only: não prosseguir com /apply; apenas confirmar sucesso
        const { t } = this.props;
        const translate = t || ((key) => key);
        await this.isPaying(false);
        alert(translate("cardSavedSuccess"));
      } catch (error) {
        await this.isPaying(false);
        const { t } = this.props;
        const translate = t || ((key) => key);
        const message =
          error && error.message
            ? error.message
            : translate("serverConnectionError") +
              " " +
              this.errorMessage(error);

        await this.setPaymentError(message);
      }
    }
  };

  errorMessage = (error) => {
    let message = "";

    if (error.response) {
      if (error.response.data) {
        if (error.response.data.messages) {
          message = error.response.data.messages
            .map((error) => error)
            .join("\n");
        } else {
          message = error.response.data;
        }
      } else {
        message = error.message;
      }
    } else if (error.message) {
      message = error.message;
    }

    return message;
  };

  finishSubmit = async (paymentId, customerId) => {
    await this.isPaying(true);

    const self = this;
    const stateObj = { ...this.state.formData };

    const total = this.getPrice().toFixed(2);

    const applyObj = {
      ApplicationChoice: "Swift",
      Campus: this.getApplicationCampus(),
      Period:
        stateObj.step2.classOption &&
        stateObj.step2.classOption.includes("Saturday")
          ? "Saturday Morning"
          : "Tuesday Thursday Evening",
      PersonalFullName: stateObj.step1.nomeCompleto,
      PersonalEmail: stateObj.step1.email,
      PersonalPhoneNumber: stateObj.step1.celular,
      IsSwift: true,
      PaymentId: paymentId,
      CustomerId: customerId,
      Amount: total
    };

    // Adicionar informações de desconto apenas se houver código de desconto
    if (this.state.discount.code) {
      applyObj.PartnerCode = this.state.discount.code;
      applyObj.PartnerDiscountPercentage = this.state.discount.percentage;
    }

    const url = getBackendBaseUrl();

    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(applyObj)
    };

    try {
      const response = await fetch(url + "/apply", requestOptions);
      const data = await response.json();

      await this.isPaying(false);

      if (data.success === true) {
        const { t } = this.props;
        const translate = t || ((key) => key);
        alert(translate("thankYouMessage"));
        if (process.env.NODE_ENV !== "test") {
          try {
            window.location.assign("https://lumos.edu");
          } catch (e) {
            // Em ambientes sem navegação (ex.: testes), ignorar.
          }
        }
      } else {
        const { t } = this.props;
        const translate = t || ((key) => key);
        const message = data.messages
          ? data.messages.map((error) => error).join("\n")
          : translate("internalServerError");

        alert(message);
      }
    } catch (error) {
      await this.isPaying(false);
      const { t } = this.props;
      const translate = t || ((key) => key);
      const message =
        translate("serverConnectionError") + " " + this.errorMessage(error);

      alert(message);
    }
  };

  render() {
    const { currentStep, formData } = this.state;
    const { t } = this.props;

    return (
      <div
        className="data-wizard-container"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 2147483647, // Z-index máximo
          pointerEvents: "auto",
          overflow: "auto",
          isolation: "isolate"
        }}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div
          className="data-wizard-content"
          style={{
            pointerEvents: "auto",
            zIndex: 100000,
            position: "relative"
          }}
        >
          {currentStep === 1 && (
            <Step1
              data={formData.step1}
              currentStep={currentStep}
              onInputChange={this.handleInputChange}
              onNext={this.nextStep}
              t={t}
            />
          )}
          {currentStep === 2 && (
            <Step2
              data={formData.step2}
              currentStep={currentStep}
              onInputChange={this.handleInputChange}
              onCampusChange={this.handleCampusChange}
              onNext={this.nextStep}
              onPrev={this.prevStep}
              t={t}
            />
          )}
          {currentStep === 3 && (
            <Step3
              data={formData.step3}
              allData={formData}
              currentStep={currentStep}
              onInputChange={this.handleInputChange}
              onSubmit={this.handleSubmit}
              onPrev={this.prevStep}
              payment={this.state.payment}
              toggleModalPayment={this.toggleModalPayment}
              handleCardInputChange={this.handleCardInputChange}
              handleInputFocus={this.handleInputFocus}
              pay={this.pay}
              canPay={this.isCardFormValid()}
              paymentMode={this.props.paymentMode}
              saveCardConsent={this.state.payment.saveCardConsent}
              onSaveCardConsentChange={this.handleSaveCardConsentChange}
              getPrice={this.getPrice}
              getBasePrice={this.getBasePrice}
              discount={this.state.discount}
              t={t}
            />
          )}
        </div>
      </div>
    );
  }
}

export default DataWizard;
